module.exports = __webpack_public_path__ + "img/simple-simulation-active.bc7935b1.svg";